import { Component, Input } from "@angular/core";

@Component({
  selector: "app-annotation",
  templateUrl: "./annotation.component.html",
  styleUrls: ["./annotation.component.css"],
})
export class AnnotationComponent {
  @Input() annotation: string = null;
  @Input() annotationIsDisabled = false;

  constructor() {}
}
